import React from "react";
import { CodeIcon } from "@heroicons/react/solid";
import Stacks from "../data/stacks.json";

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gray-900/50">
      <div className="mx-auto max-w-6xl px-6">
        <div className="flex flex-col items-center mb-16">
          <CodeIcon className="w-8 h-8 text-emerald-400 mb-4" />
          <h2 className="text-3xl sm:text-4xl font-bold text-white">Technology Stack</h2>
          <div className="section-divider" />
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-4">
          {Stacks.map(({ stack, logo }) => (
            <div
              key={stack}
              className="flex flex-col items-center gap-3 p-4 bg-gray-800/50 border border-gray-700/50 rounded-xl hover:border-emerald-500/40 hover:bg-gray-800 transition-all duration-200 hover:-translate-y-1 group cursor-default"
            >
              <img
                src={logo}
                width={40}
                height={40}
                alt={stack}
                className="group-hover:scale-110 transition-transform duration-200"
              />
              <span className="text-gray-400 text-xs text-center font-medium group-hover:text-white transition-colors">
                {stack}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
